import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Form,
  Image,
  Nav,
  Navbar,
  NavDropdown,
  Offcanvas,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Navigate, NavLink, Outlet, useNavigate } from "react-router-dom";
import { vasthuUrl } from "../component/Api";
import LangChager from "../component/LangChanger";
import { UseAuth } from "../context/Auth";
import HelmetSeo from "../component/HelmetSeo";
import Stars from "../images/Stars.png";
import { UseConsultant } from "../context/ConsultantContext";
import Help from "../component/Help";

const Main = () => {
  const { onLogout, userId } = UseAuth();
  const { walletBalance } = UseConsultant();
  console.log("walletBalance", walletBalance);
  const lang1 = window.localStorage.getItem("i18nextLng");
  const storedBalance = window.localStorage.getItem("storedBalance");
  console.log("storedBalance", storedBalance);
  console.log("after login", lang1);
  const token = window.sessionStorage.getItem("token");
  const AuthName = window.sessionStorage.getItem("authname");
  const rerender = window.sessionStorage.getItem("rerender");
  const history = useNavigate();
  const { t } = useTranslation();
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleOffcanvasClose = () => {
    setShowOffcanvas(false);
  };

  useEffect(() => {
    window.close();

    window.sessionStorage.removeItem("rerender");
    if (rerender) {
      return history(rerender);
    }
  }, [history, rerender]);

  return (
    <React.Fragment>
      <HelmetSeo
        title="Vasthuparam - Free Online Astrology Consultation"
        name="description"
        content="Vasthuparam - Free Online Astrology Consultation"
        relCa="canonical"
        hrefCa="https://www.vasthuparam.com/"
        relAl="canonical"
        hrefAl="https://m.www.vasthuparam.com/"
      />
      <Navbar
        bg="light"
        expand="lg"
        collapseOnSelect={true}
        style={{
          zIndex: 2,
          borderBottom: "1px solid #ffbb33",
          backgroundColor: "#ffbb34",
        }}
        className="nav_header"
      >
        <Container fluid style={{ backgroundColor: "#ffc33b" }}>
          {/* <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-'lg'`} /> */}
          <Navbar.Toggle
            aria-controls={`offcanvasNavbar-expand-'lg'`}
            onClick={() => setShowOffcanvas(!showOffcanvas)}
          />

          <Navbar.Brand
            style={{
              // fontWeight: "bold",
              cursor: "pointer",
              backgroundColor: "#ffc33b",
            }}
          >
            <NavLink to="/" className="nav_linkhead">
              {/* <GiLotus
                color="#ffbb33"
                size={30}
                width={30}
                height={30}
                className="d-inline-block align-top"
              />{" "} */}
              <Image
                src="Vlogo4.png"
                class="img-fluid"
                object="fill"
                width={40}
                height={40}
                style={{
                  backgroundColor: "#392600",
                  borderRadius: "7px",
                  marginRight: "0px",
                }}
                //#392600
              />
              {t("CM_PUB_LOGO_TITLE")}
            </NavLink>
          </Navbar.Brand>
          <Help />

          <div className="w-100 Header_balance">
            {/* <div
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "10px",
                flexDirection: "column",
              }}
            > */}
            <span
              style={{
                display: "flex",
              }}
            >
              <b>{t("USR.WALT.BALCE")}:</b>
              <b>₹</b>
              <b>{walletBalance}</b>
            </span>
            {AuthName ? (
              <div
                className="d-lg-none"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <span>{t("TXT.HELO.LO")}</span>
                <h5 style={{ marginRight: "1rem" }}>
                  <b style={{ color: "#fff", fontSize: "16px" }}>{AuthName}</b>
                </h5>
              </div>
            ) : null}

            <Nav className="d-none d-lg-inline header_navbar">
              <NavLink
                to="/walletoffer"
                className="nav_linkhead"
                onClick={() => history("walletoffer")}
                style={{
                  backgroundColor: "transparent",
                  color: "#1c915b",
                  padding: "3px 15px",
                }}
              >
                {t("USR.RECHARGE")}
              </NavLink>
            </Nav>
            {/* </div> */}
          </div>
          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-'lg'`}
            aria-labelledby={`offcanvasNavbarLabel-expand-'lg'`}
            placement="start"
            className="home-drawer"
            style={{ width: "70%" }}
            show={showOffcanvas}
            onHide={handleOffcanvasClose}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-'lg'`}>
                <Image
                  height={60}
                  width={65}
                  alt="logo"
                  src="Vlogo4.png"
                  style={{
                    backgroundColor: "#392600",
                    borderRadius: "7px",
                    marginRight: "10px",
                  }}
                />
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="home-drawer">
              <Nav
                className={
                  lang1 === "en"
                    ? "eng_font justify-content-end flex-grow-1 pe-3 header_navbar"
                    : lang1 === "ta"
                    ? "tam_font justify-content-end flex-grow-1 pe-3 header_navbar"
                    : "hi_font justify-content-end flex-grow-1 pe-3 header_navbar"
                }
              >
                {/* <NavLink className="nav_link" to="/"> */}
                <NavLink
                  to="/"
                  className="nav_linkhead"
                  onClick={handleOffcanvasClose}
                >
                  {t("USR.HOM.HD.HOM")}
                </NavLink>
                <NavDropdown className="nav_dpd_title" title={t("USR.NAV.VAS")}>
                  <NavDropdown.Item>
                    <NavLink
                      className="nav_link"
                      to="plotvasthu"
                      onClick={handleOffcanvasClose}
                    >
                      {t("USR.HOM.HD.VFP")}
                    </NavLink>
                  </NavDropdown.Item>
                  <NavDropdown.Divider className="all_border" />
                  <NavDropdown.Item>
                    <NavLink
                      className="nav_link"
                      to="homevasthuselection"
                      onClick={handleOffcanvasClose}
                    >
                      {t("USR.HOM.HD.VFH")}
                    </NavLink>
                  </NavDropdown.Item>
                  <NavDropdown.Divider className="all_border" />
                  <NavDropdown.Item>
                    <NavLink
                      className="nav_link"
                      to="buildingdetails"
                      onClick={handleOffcanvasClose}
                    >
                      {t("USR.HOM.HD.BD")}
                    </NavLink>
                  </NavDropdown.Item>
                </NavDropdown>
                {/* <NavLink className="nav_link" to="plotvasthu" onClick={handleOffcanvasClose}>
                  {t("USR.HOM.HD.VFP")}
                </NavLink> */}
                {/* <NavDropdown.Divider />
                <NavLink className="nav_link" to="homevasthu" onClick={handleOffcanvasClose}>
                  {t("USR.HOM.HD.VFH")}
                </NavLink>
                <NavDropdown.Divider /> */}
                {/* <NavLink className="nav_link" to="buildingdetails" onClick={handleOffcanvasClose}>
                  {t("USR.HOM.HD.BD")}
                </NavLink>
                <NavDropdown.Divider /> */}
                <NavLink
                  className="nav_linkhead"
                  to="customerpricing"
                  onClick={handleOffcanvasClose}
                >
                  {t("CM.FT.COL3.L1")}
                </NavLink>

                <NavDropdown
                  className="nav_dpd_title"
                  title={t("USR.HOM.NAV.BOOKS")}
                >
                  <NavDropdown.Item>
                    <NavLink
                      className="nav_link"
                      to="consultantbook"
                      onClick={handleOffcanvasClose}
                    >
                      {t("USR.HOM.HD.BOOK")}
                    </NavLink>
                  </NavDropdown.Item>
                  <NavDropdown.Divider className="all_border" />
                  <NavDropdown.Item>
                    <NavLink
                      className="nav_link"
                      to="consultantbooklist"
                      onClick={handleOffcanvasClose}
                    >
                      {t("USR.HOM.HD.SBOOK")}
                    </NavLink>
                  </NavDropdown.Item>
                  <NavDropdown.Divider className="all_border" />
                  <NavDropdown.Item>
                    <NavLink
                      className="nav_link"
                      to="appointmenthistory"
                      onClick={handleOffcanvasClose}
                    >
                      {t("USR.HOM.HD.BOOKH")}
                    </NavLink>
                  </NavDropdown.Item>
                </NavDropdown>

                <NavDropdown
                  className="nav_dpd_title"
                  title={t("USR.HOM.HD.A")}
                >
                  <NavDropdown.Item>
                    <NavLink
                      className="nav_link"
                      to="customeraccount"
                      onClick={handleOffcanvasClose}
                    >
                      {t("USR.HOM.HD.MA")}
                    </NavLink>
                  </NavDropdown.Item>
                  <NavDropdown.Divider className="all_border" />
                  <NavDropdown.Item>
                    <NavLink
                      className="nav_link"
                      to="customerprofile"
                      onClick={handleOffcanvasClose}
                    >
                      {t("USR.HOM.HD.PROF")}
                    </NavLink>
                  </NavDropdown.Item>
                  <NavDropdown.Divider className="all_border" />
                  <NavDropdown.Item>
                    <NavLink
                      className="nav_link"
                      to="customerpayment"
                      onClick={handleOffcanvasClose}
                    >
                      {t("USR.HOM.HD.PAY")}
                    </NavLink>
                  </NavDropdown.Item>
                  {/* <NavDropdown.Divider className="border-warning" /> */}
                  {/* <NavDropdown.Item>
                    <NavLink className="nav_link" to="paymentresponse">
                      {t("USR.HOM.HD.PAYR")}
                    </NavLink>
                  </NavDropdown.Item> */}
                  <NavDropdown.Divider className="border-warning" />
                  <NavDropdown.Item>
                    <NavLink
                      className="nav_link"
                      to="audiocall"
                      onClick={handleOffcanvasClose}
                    >
                      {t("USR.HOM.HD.AUD")}
                    </NavLink>
                  </NavDropdown.Item>
                  <NavDropdown.Divider className="border-warning" />
                  <NavDropdown.Item>
                    <NavLink
                      className="nav_link"
                      to="chathistory"
                      onClick={handleOffcanvasClose}
                    >
                      {t("USR.CHAT.HIS.HEAD")}
                    </NavLink>
                  </NavDropdown.Item>
                  {/* <NavDropdown.Divider className="all_border" />
                  <NavDropdown.Item>
                    <NavLink className="nav_link" to="customerreview">
                      {t("USR.HOM.HD.REV")}
                    </NavLink>
                  </NavDropdown.Item> */}
                  {/* <NavDropdown.Divider className="border-warning" /> */}
                  {/* <NavDropdown.Item>
                    <NavLink className="nav_link" to="myrefunds">
                  {t("USR.ACC.ACT.RFD.RFD")}
               
                    </NavLink>
                  </NavDropdown.Item> */}
                </NavDropdown>

                <NavDropdown className="nav_dpd_title" title={t("USR.NAV.PRO")}>
                  <NavDropdown.Item>
                    <NavLink
                      className="nav_link"
                      to="product"
                      onClick={handleOffcanvasClose}
                    >
                      {t("USR.NAV.PRO")}
                    </NavLink>
                  </NavDropdown.Item>
                  <NavDropdown.Divider className="all_border" />
                  <NavDropdown.Item>
                    <NavLink
                      to="likedproduct"
                      className="nav_link"
                      onClick={handleOffcanvasClose}
                    >
                      {t("HOM.NAV.PRO.LIK")}
                    </NavLink>
                  </NavDropdown.Item>
                  <NavDropdown.Divider className="all_border" />
                  <NavDropdown.Item>
                    <NavLink
                      to="bookedproduct"
                      className="nav_link"
                      onClick={handleOffcanvasClose}
                    >
                      {t("HOM.NAV.PRO.BOK")}
                    </NavLink>
                  </NavDropdown.Item>
                </NavDropdown>
                <NavDropdown.Divider />

                <Button className="all_btn logout_btn" onClick={onLogout}>
                  {t("USR.HOM.BTN.LOGOUT")}
                </Button>
                <NavDropdown.Divider />
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
          <Form.Group className="langchange header_language" controlId="lang">
            {AuthName ? (
              <div
                className="d-none d-lg-inline"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <span>{t("TXT.HELO.LO")}</span>
                <h5 style={{ marginRight: "1rem" }}>
                  <b style={{ color: "#fff", fontSize: "16px" }}>{AuthName}</b>
                </h5>
              </div>
            ) : null}
          </Form.Group>
          <div
            className="w-100 mb-1"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
            }}
          >
            <Button
              className="all_btn d-lg-none important-green"
              onClick={() => history("walletoffer")}
            >
              <span style={{ color: "#1c915b !important" }}>
                {" "}
                {t("USR.RECHARGE")}
              </span>
            </Button>
            <LangChager className="m-0" />
            <Button className="all_btn logout_btn d-lg-none" onClick={onLogout}>
              {t("USR.HOM.BTN.LOGOUT")}
            </Button>
          </div>
        </Container>
      </Navbar>
      <Outlet />
    </React.Fragment>
  );
};

export default Main;
